import { useQuery } from "@tanstack/react-query";
import { adeclaBackAPI } from "api/helper";

export const PERSONNUMMER_STATUS_KEY = ["personnummer", "status"];

/**
 * Har den inloggade användaren skickat in ett personnummer (ADE-50)? API:t
 * svarar ja när det finns minst en rad med användarens FA-användarnamn.
 */
export const useGetPersonnummerStatus = () => {
  const { data, isError } = useQuery<{ hasPersonnummer: boolean }, Error>(
    PERSONNUMMER_STATUS_KEY,
    () =>
      adeclaBackAPI<{ hasPersonnummer: boolean }>({
        path: "personnummer/status",
        method: "GET",
      }),
    { staleTime: Infinity }
  );

  return { hasPersonnummer: data?.hasPersonnummer, isError };
};
